import styled from '@emotion/styled'

export const MessageStyled = styled('p')({
  textAlign: 'left',
  wordWrap: 'normal',
  fontSize: '1.2rem',
  lineHeight: 1.5,
  margin: '1rem 0',
})
